import React from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../store/slices/user/slice';
import { useOutletContext } from 'react-router-dom';
import { Container, Content, Form } from './ChatterProfilePage.styles';
import { Header, Input } from '../../../components';

const ChatterProfilePage = () => {
  const user = useSelector(selectUser);

  const [setShowContent] = useOutletContext();

  return (
    <Container>
      <Form>
        <Header title="Personal Info" setShowContent={setShowContent}></Header>
        <Content>
          <Input label="Email" value={user.email} disabled />
          <Input label="Profile Name" value={user.name} disabled />
        </Content>
      </Form>
    </Container>
  );
};

export default ChatterProfilePage;
